// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"a4e3b4c4","336":"c39bb1bf","625":"9a0fe7eb","850":"91fc47fa"}[chunkId] + ".css";
};